import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const getCostEstimationReport = async function (filters) {
  try {
    const res = await axios.get(urls.getCostEstimationReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getAgingReport = async function (filters) {
  try {
    const res = await axios.get(urls.getAgingReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchOrderShipperReport = async function (filters) {
  try {
    const res = await axios.get(urls.getOrderShipperReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchBasp = async function (filters) {
  try {
    const res = await axios.get(urls.getListBasp + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  getCostEstimationReport,
  getAgingReport,
  fetchOrderShipperReport,
  fetchBasp
}
